
import React from 'react';

import Exhibition from './Exhibition';
import Expertoptimization from './Expertoptimization';
import Refrigerator from './Refrigerator';
import Exhibitiontable from './Exhibitiontable';


const Moldingexhibit = () => {
    return (
        <div>
            <Exhibition />
            <Expertoptimization />
            <Refrigerator />
            <Exhibitiontable />

        </div>
    );
};

export default Moldingexhibit;
